import type { ResultOkType } from 'ts-results-es';

import { type BodyOf, FeApi } from '..';
import { VehicleSchema } from '../domain/entities/vehicle';
import type { IVehicleRepository } from '../domain/repositories/vehicle.repository';

export namespace VehicleRepositoryMapper {
  export namespace getAccureId {
    export const outputSchema = VehicleSchema;

    export function bodyFromInput(
      input: IVehicleRepository.GetPreviewByIdInput,
    ): BodyOf<typeof FeApi.customerInfosV1VehicleAccureIdRetrieve> {
      return { frontendId: input.id ?? '' };
    }

    export function outputFromData(
      fullFrontendId: string,
      accureId: string | undefined,
    ): Promise<ResultOkType<IVehicleRepository.GetPreviewByIdOutput>> {
      return outputSchema.parseAsync({
        id: accureId ?? '',
        fullFrontendId,
      });
    }
  }
}
